'use client';
import React from 'react';
import { Form, Input } from 'antd';
import { useTranslations } from 'next-intl';
import InputForm from '@/ui/shared/components/inputForm';
import { useController } from './Controller';
import ErrorAlert from '@/ui/features/authentication/components/errorAlert';
import Image from 'next/image';
import AfiwaButton from '@/ui/shared/components/afiwaButton';

interface Props {
  setToggle: React.Dispatch<React.SetStateAction<boolean>>;
}
function RecoverPassword({ setToggle }: Props) {
  const { loading, apiError, handlePasswordRecover } = useController(setToggle);

  const [form] = Form.useForm();
  const auth = useTranslations('auth');

  const handleSubmit = async (values: any) => {
    const payload = {
      email: values.email,
    };

    await handlePasswordRecover(payload);
  };

  return (
    <Form
      layout="vertical"
      onFinish={handleSubmit}
      form={form}
      name="recover"
      scrollToFirstError
      requiredMark={false}
    >
      {/* FORM-ERRORS */}
      <ErrorAlert errorType={apiError} />

      {/* EMAIL */}
      <InputForm
        label={auth('forms.labels.email')}
        name="email"
        placeholder={auth('forms.placeholders.sampleMail')}
        rules={[
          { required: true, message: auth('forms.errors.fillEmail') },
          {
            type: 'email',
            message: auth('forms.errors.invalidMail'),
          },
        ]}
        component={
          <Input
            required
            placeholder={auth('forms.placeholders.sampleMail')}
            size="large"
            onInput={(e) =>
              (e.currentTarget.value =
                e.currentTarget.value.toLocaleLowerCase())
            }
            prefix={
              <Image
                src={'/icons/enveloppe.svg'}
                alt="enveloppe-icon"
                height={16}
                width={16}
                className={'mr-2'}
              />
            }
          />
        }
      />

      <AfiwaButton
        type={'primary'}
        htmlType={'submit'}
        loading={loading}
        text={auth('send')}
        className={'mt-6 flex w-full justify-center'}
      />
    </Form>
  );
}

export default RecoverPassword;
